import DOMPurify from "dompurify";

export const sanitizeHTML = (htmlContent) => {
  return DOMPurify.sanitize(htmlContent);
};

// input: string, allowedTags: string[]
export function sanitizeInputManuallyWithAllowedStrings(
  input,
  allowedTags = []
) {
  // Define a regex pattern to detect common XSS vectors
  const xssPattern =
    /<script.*?>.*?<\/script.*?>|<.*?javascript:.*?>.*?<\/.*?>|<.*?on.*?=.*?>/gi;

  // If the input matches the pattern, return an empty string
  if (xssPattern.test(input)) {
    return "";
  }

  // Remove any tags not included in the allowedTags array
  const sanitizedInput = input.replace(/<\/?[^>]+(>|$)/g, (tag) => {
    const tagName = tag.replace(/<\/?([^>\s\/]+).*?>/g, "$1");
    return allowedTags.includes(tagName) ? tag : "";
  });

  return sanitizedInput;
}

export const sanitizeInputManually = (input) => {
  const sanitized = input
    .replace(/<\/?[^>]+(>|$)/g, "") // Remove any HTML tags
    .replace(/(http|https|ftp|ftps|www\.)[^\s]+/gi, "") // Remove URLs
    .replace(/['";<>]/g, ""); // Strip dangerous characters
  return sanitized;
};

export default sanitizeHTML;
